import React, { useState } from 'react';
import {
  FormControlLabel, Switch, Tooltip, Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import {
  chosen, disable, enable, permission, supported,
} from './desktopAlerts';
import brand from '../shell/brand';

// Where somebody turns on alerts that reach them outside the page.
//
// It sits on the exceptions page because that is where the bell lands and where alerts are worked
// through, so the question "can I be told when I am not looking at this?" is asked in the one place
// the answer matters. The browser's permission prompt is raised by this switch and nowhere else.
export default function DesktopAlertSwitch() {
  const account = useSelector((state) => state.session.user);
  const [state, setState] = useState(() => permission());
  const [on, setOn] = useState(() => chosen(account));

  if (!supported()) return null;

  const blocked = state === 'denied';
  const change = async (event) => {
    if (!event.target.checked) {
      disable(account);
      setOn(false);
      return;
    }
    const result = await enable(account);
    setState(result);
    setOn(result === 'granted');
  };

  const explanation = blocked
    ? `This browser is blocking notifications for ${brand.name}. Allow them in the browser's site settings, then switch this on again.`
    : `Urgent alerts are shown by this device even when ${brand.name} is behind another window, and on a phone where it has been installed, even when it is closed. The tab title carries the count either way.`;

  return (
    <Tooltip title={explanation}>
      <FormControlLabel
        sx={{ mr: 0 }}
        control={<Switch size="small" checked={on && !blocked} onChange={change} inputProps={{ 'aria-label': 'Alert me on this device' }} />}
        label={(
          <Typography variant="body2" color={blocked ? 'error' : 'text.secondary'}>
            {blocked ? 'Desktop alerts blocked' : 'Alert me on this device'}
          </Typography>
        )}
      />
    </Tooltip>
  );
}
